<template>
    <div>
        <template v-if="$GlobalStore.confirmType() === $GlobalStore.CONFIRM_TYPE.DEFAULT">
            <div style="position:fixed; left:0px; top:0px; width:100%; height:100%; background-color: rgba(0,0,0,0.3); display:flex; justify-content: center; align-items: center;" @click="cancel">
                <div style="background-color: white; width:250px; min-height:190px;display:flex; flex-direction:column; border-radius:10px;text-align:center;" @click.stop="() => { }">
                    <div style="height:75px; display:flex; flex-direction: column-reverse; flex:1;">
                        <div v-html="$GlobalStore.confirmMsg()" style="line-height:17px; font-size:15px;"></div>
                    </div>
                    <div style="padding-bottom:20px;">
                        <div @click.stop="ok" style="margin-top:30px; display:inline-block; padding:6px; color:white; text-align:center;border-radius:10px; font-size:11px; background-color: #ff6100;width:150px; ">{{ $GlobalStore.confirmOkName() }}</div>
                        <div @click.stop="cancel" style="margin-top:10px; display:inline-block; padding:6px;text-align:center;border-radius:10px; font-size:11px; background: #e7e7e7;width:150px; ">{{ $GlobalStore.confirmCancelName() }}</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="$GlobalStore.confirmType() === $GlobalStore.CONFIRM_TYPE.VERSION2">
            <div style="position:fixed; left:0px; top:0px; width:100%; height:100%; background-color: rgba(0,0,0,0.3); display:flex; justify-content: center; align-items: center;" @click="cancel"></div>
            <div :style="{ top: isClose ? top : '120%' }" style="width:300px; transition: top .5s; position:fixed; left:50%;  transform: translate(-50%, -50%);background-color: white; display:flex; flex-direction:column; border-radius:10px; padding:20px 15px; " @click.stop="() => { }">
                <div style=" display:flex; flex:1;">
                    <div v-html="$GlobalStore.confirmMsg()" style="font-size:16px; line-height:21px; color:#757575;"></div>
                </div>
                <div style=" display:flex; margin-top:20px; justify-content: center; align-items: center; gap: 6px;">
                    <div @click.stop="ok" style="border-radius:25px ; padding:10px 20px; text-align:center; font-size:15px; border:1px solid #ff6100; color:black; flex: 1; ">{{ $GlobalStore.confirmOkName() }}</div>
                    <div @click.stop="cancel" style="border-radius:25px ; padding:10px 20px; text-align:center; font-size:15px; border:1px solid #F5F5F5; flex: 1;">{{ $GlobalStore.confirmCancelName() }}</div>
                </div>
            </div>
        </template>
        <template v-else-if="$GlobalStore.confirmType() === $GlobalStore.CONFIRM_TYPE.VERSION3">
            <div style="position:fixed; left:0px; top:0px; width:100%; height:100%; background-color: rgba(0,0,0,0.3); display:flex; justify-content: center; align-items: center;" @click="cancel"></div>
            <div :style="{ top: isClose ? top : '120%' }" style="transition: top .5s; position:fixed; left:50%;  transform: translate(-50%, -50%);background-color: white; width:340px; display:flex; flex-direction:column; border-radius:10px; padding:30px 20px; " @click.stop="() => { }">
                <div style=" display:flex; flex:1;">
                    <div v-html="$GlobalStore.confirmMsg()" style="font-size:16px; line-height:21px; color:#757575;"></div>
                </div>
                <div style="">
                    <div @click.stop="ok" style="border-radius:25px ; padding:10px 20px; text-align:center; font-size:15px; border:1px solid #ff6100; color:black;">{{ $GlobalStore.confirmOkName() }}</div>
                    <div @click.stop="cancel" style="border-radius:25px ; padding:10px 20px; text-align:center; font-size:15px; border:1px solid #F5F5F5; margin-top:10px;">{{ $GlobalStore.confirmCancelName() }}</div>
                </div>
            </div>
        </template>
        <!-- 승인 -->
        <template v-else-if="$GlobalStore.confirmType() === $GlobalStore.CONFIRM_TYPE.VERSION4">
            <div style="position:fixed; left:0px; top:0px; width:100%; height:100%; background-color: rgba(0,0,0,0.3); display:flex; justify-content: center; align-items: center;" @click="cancel"></div>
            <div :style="{ top: isClose ? top : '120%' }" style="transition: top .5s; position:fixed; left:50%;  transform: translate(-50%, -50%);background-color: white; width:334px; display:flex; flex-direction:column; border-radius:10px; padding:0px 0px 15px 0px; " @click.stop="() => { }">
                <div style=" display:flex; flex:1;">
                    <div v-html="$GlobalStore.confirmMsg()" style="font-size:14px; line-height:21px; color:#606060; text-align:center; font-weight:500; width:100%;"></div>
                </div>
                <div style=" display:flex; margin-top:20px; justify-content: center; align-items: center; gap: 6px; padding:0px 15px;">
                    <div v-if="$GlobalStore.confirmCancelName() != null" @click.stop="cancel" style="border-radius:8px; flex:1; display:grid; place-items:center; height:36px; background-color: #F5F5F5; color:#210F03; font-size:14px; font-weight:bold;">{{ $GlobalStore.confirmCancelName() }}</div>
                    <div v-if="$GlobalStore.confirmOkName() != null" @click.stop="ok" style="border-radius:8px; flex:1; display:grid; place-items:center; background-color: #210f03; height:36px; color:white; font-size:14px; font-weight:bold;">{{ $GlobalStore.confirmOkName() }}</div>
                </div>
            </div>
        </template>
        <!-- 거절 -->
        <template v-else-if="$GlobalStore.confirmType() === $GlobalStore.CONFIRM_TYPE.VERSION5">
            <div style="position:fixed; left:0px; top:0px; width:100%; height:100%; background-color: rgba(0,0,0,0.3); display:flex; justify-content: center; align-items: center;" @click="cancel"></div>
            <div :style="{ top: isClose ? top : '120%' }" style="transition: top .5s; position:fixed; left:50%;  transform: translate(-50%, -50%);background-color: white; width:300px; display:flex; flex-direction:column; border-radius:10px;" @click.stop="() => { }">
                <div style=" display:flex; flex:1;">
                    <div v-html="$GlobalStore.confirmMsg()" style="font-size:16px; line-height:21px; color:#757575; text-align:center;font-weight:500; width:100%;"></div>
                </div>
                <div style="height:1px; background-color: #EBEBEB;"></div>
                <div style=" display:flex; align-items: center;padding: 12px 0px;">
                    <div @click.stop="cancel" style=" padding:10px 20px; text-align:center; font-size:14px; color:#210F03; flex: 1; font-weight:bold;">{{ $GlobalStore.confirmCancelName() }}</div>
                    <div style="width:1px; background-color: #EBEBEB; height:34px;"></div>
                    <div @click.stop="ok" style=" padding:10px 20px; text-align:center; font-size:14px; color:var(--color-main); flex: 2; font-weight:bold;">{{ $GlobalStore.confirmOkName() }}</div>
                </div>
            </div>
        </template>
        <template v-else-if="$GlobalStore.confirmType() === $GlobalStore.CONFIRM_TYPE.VERSION6">
            <div style="position:fixed; left:0px; top:0px; width:100%; height:100%; background-color: rgba(0,0,0,0.3); display:flex; justify-content: center; align-items: center;" @click="cancel"></div>
            <div :style="{ top: isClose ? top : '120%' }" style="transition: top .5s; position:fixed; left:50%;  transform: translate(-50%, -50%);background-color: white; width:300px; display:flex; flex-direction:column; border-radius:10px;" @click.stop="() => { }">
                <div style=" display:flex; flex:1;">
                    <div v-html="$GlobalStore.confirmMsg()" style="font-size:16px; line-height:21px; color:#757575; text-align:center;font-weight:500; width:100%;"></div>
                </div>
                <div style="height:1px; background-color: #EBEBEB;"></div>
                <div style=" display:flex; align-items: center;padding: 12px 0px;">
                    <div @click.stop="cancel" style=" padding:10px 20px; text-align:center; font-size:14px; color:#210F03; flex: 1; font-weight:bold;">{{ $GlobalStore.confirmCancelName() }}</div>
                    <div style="width:1px; background-color: #EBEBEB; height:34px;"></div>
                    <div @click.stop="ok" style=" padding:10px 20px; text-align:center; font-size:14px; color:var(--color-main); flex: 2; font-weight:bold;">{{ $GlobalStore.confirmOkName() }}</div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "Confirm",
    data() {
        return {
            isClose: true,
            top: '100%'
        }
    },
    methods: {
        ok() {
            this.$GlobalStore.okConfirm();
            this.$GlobalStore.hideConfirm(true);
            this.$GlobalStore.closeLastPop(false);
        },
        cancel() {
            this.cancelPost();
            this.$GlobalStore.closeLastPop(false);
        },
        cancelPost() {
            if (this.$GlobalStore.isJoin()) {
                this.$Util.sendEventClick('조인_조인생성_취소하기')
            }
            this.isClose = false
            setTimeout(() => {
                this.$GlobalStore.hideConfirm();
            }, 300)
        },
    },
    mounted() {
        this.$GlobalStore.addPopFlag(() => {
            this.cancelPost();
        });

        this.top = '50%';
    }
}
</script>

<style scoped></style>